import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { alignContent, alignItems, alignSelf, background, backgroundImage, backgroundPosition, backgroundRepeat, backgroundSize, borderColor, borderRadius, borders, boxShadow, color, display, flex, flexBasis, flexDirection, flexWrap, fontFamily, fontSize, fontStyle, fontWeight, gridArea, gridColumn, gridRow, height, justifyContent, justifySelf, lineHeight, maxHeight, maxWidth, minHeight, minWidth, opacity, overflow, space, style, textAlign, verticalAlign, width, zIndex } from 'styled-system';
import positionHelpers from './utils/position';
import columnCount from './utils/columnCount';
import breakInside from './utils/breakInside';
import { textDecoration, textTransform, whiteSpace } from './utils/typography';
import cursor from './utils/cursor';
const borderWidth = style({
  prop: 'borderWidth',
  cssProperty: 'borderWidth'
});
const WrappedBox = styled.div.withConfig({
  displayName: "Box__WrappedBox",
  componentId: "sc-qa4pek-0"
})(["&&{", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";}"], alignContent, alignItems, alignSelf, background, backgroundImage, backgroundPosition, backgroundRepeat, borderRadius, boxShadow, backgroundSize, borders, borderColor, borderWidth, breakInside, color, columnCount, cursor, display, flex, height, width, opacity, fontFamily, flexBasis, overflow, flexDirection, flexWrap, fontSize, fontStyle, fontWeight, gridArea, gridColumn, gridRow, justifyContent, justifySelf, lineHeight, maxHeight, maxWidth, minHeight, minWidth, space, textAlign, textTransform, textDecoration, positionHelpers, verticalAlign, whiteSpace, zIndex);
const Box = /*#__PURE__*/React.forwardRef(({
  className,
  runningText,
  showSkeleton,
  large,
  boxRef,
  ...rest
}, ref) => /*#__PURE__*/React.createElement(WrappedBox, _extends({}, rest, {
  ref: ref || boxRef,
  className: classNames(className, {
    'bp4-running-text': runningText,
    'bp4-text-large': large,
    'bp4-skeleton': showSkeleton
  })
})));
export default Box;